import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

import { Theme } from '@constants';

import { styles } from './styles';

import Manifest from '../../../manifest.json';
import { DEBUG } from '../../helpers/Platform';
import { TWCText } from '../primitives/TWCText/TWCText';

const tPath = 'settingsPage.';

export const BuildVersion = () => {
  const { t } = useTranslation();

  return (
    <View style={styles.wrapper}>
      <TWCText noTestID style={[Theme.styles.headerText, styles.buildVersion]}>
        {t(`${tPath}buildInfo.version`)}
        {` ${Manifest?.app_version}`}
      </TWCText>
      <TWCText noTestID style={[Theme.styles.headerText, styles.buildVersion]}>
        {t(`${tPath}buildInfo.buildNumber`)}
        {` ${Manifest?.build_number}`}
      </TWCText>
      {DEBUG ? (
        <TWCText noTestID style={[Theme.styles.headerText, styles.buildVersion]}>
          {t(`${tPath}buildInfo.branch`)}
          {` ${Manifest?.branch_name}`}
        </TWCText>
      ) : null}
    </View>
  );
};
